"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require("./synonyms.js"),
  getSynonym = _require.getSynonym;
var _require2 = require("lodash"),
  map = _require2.map;
var _require3 = require("./converter.js"),
  dxaToPoint = _require3.dxaToPoint,
  pointToDXA = _require3.pointToDXA;
var xml2str = require("docxtemplater").DocUtils.xml2str;
var _require4 = require("docxtemplater/js/lexer.js"),
  xmlparse = _require4.xmlparse;
var pushArray = require("./push-array.js");
var defaultLeftMargin = 47;
function getXmlPath(xml, path) {
  for (var i = 0, len = xml.childNodes.length; i < len; i++) {
    var child = xml.childNodes[i];
    var tagName = child.tagName;
    if (tagName === path) {
      var result = "";
      for (var j = 0, len2 = child.childNodes.length; j < len2; j++) {
        var subchild = child.childNodes[j];
        result += xml2str(subchild);
      }
      return result;
    }
  }
  return "";
}
function getBorder(border, borderProps) {
  if (border == null) {
    return "";
  }
  border.size || (border.size = 4);
  border.color || (border.color = "000000");
  if (border === "none" || border.type === "none") {
    border.val = "nil";
  } else {
    border.val = "single";
  }
  function gen(position) {
    if (!borderProps[position]) {
      if (border.val === "nil") {
        return "<w:".concat(position, " w:val=\"nil\"/>");
      }
      return "<w:".concat(position, " w:val=\"").concat(border.val, "\" w:sz=\"").concat(border.size, "\" w:space=\"0\" w:color=\"").concat(border.color, "\"/>");
    }
    var val = borderProps[position].style || border.val;
    if (val === "nil") {
      return "<w:".concat(position, " w:val=\"nil\"/>");
    }
    return "<w:".concat(position, " w:val=\"").concat(val, "\" w:sz=\"").concat(borderProps[position].sz || border.size, "\" w:space=\"0\" w:color=\"").concat(borderProps[position].color || border.color, "\"/>");
  }
  return "<w:tcBorders>\n\t\t".concat(gen("top"), "\n\t\t").concat(gen("left"), "\n\t\t").concat(gen("bottom"), "\n\t\t").concat(gen("right"), "\n\t\t").concat(gen("insideH"), "\n\t\t").concat(gen("insideV"), "\n\t</w:tcBorders>");
}

// eslint-disable-next-line complexity
function getStyleFromCellPosition(xmlStyle, firstRow, lastRow, firstCol, lastCol, row, col) {
  var trXml = [];
  var pr = xmlStyle.getElementsByTagName("w:tblStylePr");
  for (var i = 0, len = pr.length; i < len; i++) {
    var p = pr[i];
    if (p.getAttribute("w:type") === "neCell" && firstRow && lastCol) {
      trXml.push(p);
    }
    if (p.getAttribute("w:type") === "nwCell" && firstRow && firstCol) {
      trXml.push(p);
    }
    if (p.getAttribute("w:type") === "swCell" && lastRow && firstCol) {
      trXml.push(p);
    }
    if (p.getAttribute("w:type") === "seCell" && lastRow && lastCol) {
      trXml.push(p);
    }
  }
  if (trXml.length) {
    return trXml;
  }
  for (var _i = 0, _len = pr.length; _i < _len; _i++) {
    var _p = pr[_i];
    if (_p.getAttribute("w:type") === "firstRow" && firstRow) {
      trXml.push(_p);
    }
    if (_p.getAttribute("w:type") === "lastRow" && lastRow) {
      trXml.push(_p);
    }
    if (_p.getAttribute("w:type") === "firstCol" && firstCol) {
      trXml.push(_p);
    }
    if (_p.getAttribute("w:type") === "lastCol" && lastCol) {
      trXml.push(_p);
    }
  }
  if (trXml.length) {
    return trXml;
  }
  for (var _i2 = 0, _len2 = pr.length; _i2 < _len2; _i2++) {
    var _p2 = pr[_i2];
    if (_p2.getAttribute("w:type") === "band1Horz" && row % 2 === 0) {
      trXml.push(_p2);
    }
    if (_p2.getAttribute("w:type") === "band2Horz" && row % 2 === 1) {
      trXml.push(_p2);
    }
    if (_p2.getAttribute("w:type") === "band1Vert" && col % 2 === 0) {
      trXml.push(_p2);
    }
    if (_p2.getAttribute("w:type") === "band2Vert" && col % 2 === 1) {
      trXml.push(_p2);
    }
  }
  if (trXml.length) {
    return trXml;
  }
  for (var _i3 = 0, _len3 = pr.length; _i3 < _len3; _i3++) {
    var _p3 = pr[_i3];
    if (_p3.getAttribute("w:type") === "wholeTable") {
      trXml.push(_p3);
    }
  }
  if (trXml.length) {
    return trXml;
  }
  return [xmlStyle];
}
module.exports = function table(table, element, transformer, paragraphRunProperties) {
  var props = [];
  var xmlStyle = null;
  var xmlBasedOn = null;
  function tr(_ref, row, data) {
    var repeatHeaderRow = _ref.repeatHeaderRow,
      cantSplit = _ref.cantSplit,
      parts = _ref.parts;
    var isFirst = row === 0;
    var isLast = row === data.length - 1;
    var trProps = [];
    if (repeatHeaderRow) {
      trProps.push("<w:tblHeader/>");
    }
    if (cantSplit) {
      trProps.push("<w:cantSplit/>");
    }
    return "<w:tr>\n\t\t".concat(trProps.length > 0 ? "<w:trPr>".concat(trProps.join(""), "</w:trPr>") : "<w:trPr/>", "\n\t\t").concat(parts.map(tc.bind(null, isFirst, isLast, row)).join("\n"), "\n\t\t</w:tr>");
  }
  var _table = table,
    margin = _table.margin;
  if (table.data.length === 0 || table.data.length === 1 && table.data[0].length === 1 && table.data[0][0].empty === true) {
    return "";
  }

  // eslint-disable-next-line complexity
  function tc(firstRow, lastRow, row, value, col, data) {
    var _element$customProper;
    var firstCol = col === 0;
    var lastCol = data.length - 1 === col;
    var customProperties = value.customProperties;
    var newRunProperties = value.newRunProperties,
      empty = value.empty,
      colspan = value.colspan,
      rowspan = value.rowspan,
      element = value.element,
      bgColor = value.bgColor,
      width = value.width,
      vAlign = value.vAlign,
      vMerge = value.vMerge,
      borderColor = value.borderColor,
      padding = value.padding,
      borderProps = value.border;
    var children = element.children;
    if (empty === true) {
      return "<w:tc>\n\t\t\t<w:tcPr>\n\t\t\t</w:tcPr>\n\t\t\t<w:p>\n\t\t\t<w:r>\n\t\t\t<w:t></w:t>\n\t\t\t</w:r>\n\t\t\t</w:p>\n\t\t\t</w:tc>";
    }
    var border = table.border;
    if (borderColor && typeof table.border !== "string") {
      border = _objectSpread(_objectSpread({}, table.border), {}, {
        color: borderColor
      });
    }
    var gridSpan = colspan ? "<w:gridSpan w:val=\"".concat(colspan, "\"/>") : "";
    if (vMerge === "continue") {
      return "<w:tc>\n\t\t\t<w:tcPr>\n\t\t\t".concat(getBorder(border, borderProps), "\n\t\t\t").concat(gridSpan, "\n\t\t\t<w:vMerge w:val=\"continue\"/>\n\t\t\t</w:tcPr>\n\t\t\t<w:p>\n\t\t\t<w:pPr>\n\t\t\t<w:rPr/>\n\t\t\t</w:pPr>\n\t\t\t<w:r>\n\t\t\t<w:rPr/>\n\t\t\t</w:r>\n\t\t\t</w:p>\n\t\t\t</w:tc>");
    }
    var tcMarContent;
    if (Object.keys(padding).length > 0) {
      tcMarContent = map(padding, function (value, key) {
        return "<w:".concat(key, " w:w=\"").concat(value, "\" w:type=\"dxa\"/>");
      }).join("");
    } else {
      tcMarContent = '<w:left w:w="45" w:type="dxa"/>';
    }
    var wtcMar = "<w:tcMar>".concat(tcMarContent, "</w:tcMar>");
    var vMergeTag = rowspan > 1 ? '<w:vMerge w:val="restart"/>' : "";
    var wvAlign = vAlign ? "<w:vAlign w:val=\"".concat(vAlign, "\"/>") : "";
    var wshd = bgColor ? "<w:shd w:val=\"clear\" w:color=\"".concat(bgColor, "\" w:fill=\"").concat(bgColor, "\"/>") : '<w:shd w:fill="auto" w:val="clear"/>';
    if ((_element$customProper = element.customProperties) !== null && _element$customProper !== void 0 && _element$customProper.resetList) {
      customProperties = customProperties.filter(function (prop) {
        return prop.tag !== "w:numPr";
      });
    }
    var paragraphContent = "";
    var myStyle = xmlStyle ? getStyleFromCellPosition(xmlStyle, firstRow, lastRow, firstCol, lastCol, row, col) : null;
    if (myStyle) {
      var p = myStyle.map(function (x) {
        return getXmlPath(x, "w:rPr");
      }).join("");
      var xml = xmlparse(p, {
        text: [],
        other: transformer.docxtemplater.fileTypeConfig.tagsXmlLexedArray
      });
      pushArray(newRunProperties, xml);
    }
    if (empty !== true) {
      paragraphContent = transformer.getBlockContent(children, newRunProperties, customProperties, paragraphRunProperties);
    }
    if (paragraphContent.indexOf("<w:p") === -1) {
      paragraphContent = "<w:p><w:r><w:t></w:t></w:r></w:p>";
    }
    var trXml = "\n\t\t\t<w:tcW w:w=\"".concat(width, "\" w:type=\"dxa\"/>\n\t\t\t").concat(getBorder(border, borderProps), "\n\t\t\t").concat(gridSpan, "\n\t\t\t").concat(vMergeTag, "\n\t\t\t").concat(wshd, "\n\t\t\t").concat(wvAlign, "\n\t\t\t").concat(wtcMar, "\n\t\t");
    if (xmlStyle) {
      trXml = myStyle.map(function (x) {
        return getXmlPath(x, "w:tcPr");
      }).join("");
    }
    return "\n\t\t\t<w:tc>\n\t\t\t<w:tcPr>".concat(trXml, "</w:tcPr>\n\t\t\t").concat(paragraphContent, "\n\t\t\t</w:tc>\n\t\t\t");
  }
  var _table2 = table,
    data = _table2.data,
    colGrid = _table2.colGrid;
  var wtblGrid = colGrid.map(function (width) {
    return "<w:gridCol w:w=\"".concat(width, "\"/>");
  }).join("");
  if (element.customProperties) {
    props = Object.keys(element.customProperties).reduce(function (props, key) {
      if (key === "tblStyle") {
        var style = element.customProperties[key];
        xmlStyle = transformer.styleManager.getStyle({
          type: "table",
          id: style
        });
        if (xmlStyle == null) {
          return props;
        }
        props.push("<w:".concat(key, " w:val=\"").concat(style, "\"/>"));
        var basedOn = xmlStyle.getElementsByTagName("w:basedOn")[0];
        if (basedOn) {
          xmlBasedOn = transformer.styleManager.getStyle(basedOn.getAttribute("w:val"));
        }
      }
      return props;
    }, []);
  }
  var pStyle = "Normal";
  pStyle = getSynonym(pStyle, transformer.synonyms);
  var leftMargin = table.margin.left == null ? defaultLeftMargin : table.margin.left;
  var fixed = table.layout === "fixed";
  function getNext(element) {
    var next = element.next;
    if (!next) {
      return null;
    }
    if (next.type === "text") {
      return getNext(next);
    }
    return next;
  }
  function getNextP(element) {
    var n = getNext(element);
    if (n) {
      return n;
    }
    if (element.parent) {
      return getNextP(element.parent);
    }
    return null;
  }
  function getBottomParagraph() {
    var marginBottom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var breakAfter = false;
    if (table.customProperties) {
      table.customProperties.some(function (prop) {
        if (prop === "break-page-after") {
          breakAfter = true;
          return true;
        }
      });
    }
    if (marginBottom === 0 && !breakAfter) {
      var np = getNextP(element);
      var next = getNext(element);
      if (element.parent.tagName === "td" && !next) {
        return "<w:p/>";
      }
      if (next) {
        return "";
      }
      if (!np) {
        return "";
      }
    }
    var fontSize = 11;
    var points = Math.max(dxaToPoint(marginBottom), 1);
    var after = 0;
    if (points <= fontSize) {
      fontSize = Math.max(points, 1);
    } else {
      points -= fontSize;
      after = pointToDXA(points);
    }
    return "<w:p>\n\t\t<w:pPr>\n\t\t\t<w:pStyle w:val=\"".concat(pStyle, "\"/>\n\t\t\t<w:spacing w:before=\"0\" w:after=\"").concat(after, "\"/>\n\t\t\t<w:rPr>\n\t\t\t\t<w:sz w:val=\"").concat(fontSize * 2, "\"/>\n\t\t\t\t<w:szCs w:val=\"").concat(fontSize * 2, "\"/>\n\t\t\t</w:rPr>\n\t\t</w:pPr>\n\t\t").concat(breakAfter ? '<w:r><w:br w:type="page"/></w:r>' : "<w:r/>", "\n\t\t</w:p>");
  }
  var value = "\n    <w:tbl>\n      <w:tblPr>\n        ".concat(props.join(""), "\n        <w:tblW w:w=\"").concat(table.width, "\" w:type=\"dxa\"/>\n        <w:jc w:val=\"").concat(table.alignment, "\"/>\n        ").concat(fixed ? '<w:tblLayout w:type="fixed"/>' : "", "\n\t\t").concat(xmlStyle ? getXmlPath(xmlStyle, "w:tblPr") : "\n\t\t\t<w:tblInd w:w=\"".concat(leftMargin, "\" w:type=\"dxa\"/>\n\t\t\t<w:tblCellMar>\n\t\t\t  <w:top w:w=\"55\" w:type=\"dxa\"/>\n\t\t\t  <w:left w:w=\"45\" w:type=\"dxa\"/>\n\t\t\t  <w:bottom w:w=\"55\" w:type=\"dxa\"/>\n\t\t\t  <w:right w:w=\"55\" w:type=\"dxa\"/>\n\t\t\t</w:tblCellMar>\n\t\t"), "\n\t\t").concat(xmlBasedOn ? "" : "", "\n      </w:tblPr>\n      <w:tblGrid>\n      ").concat(wtblGrid, "\n      </w:tblGrid>\n      ").concat(data.map(tr).join("\n"), "\n    </w:tbl>").concat(getBottomParagraph(margin.bottom));
  return value;
};